import firebase from 'firebase';
import { useEffect, useState } from 'react';
import { firestoreCollection } from 'util/constants';
import { DefaultsType } from '../views/admin/types';

/**
 * The project field labels (the single document in `defaults`). Fixed 5 Nov 2026: Firestore can send
 * an empty first snapshot (e.g. from its local cache), which used to crash the page reading docs[0];
 * the listener now also stops when the component goes away.
 */
const useDefaultFieldsListener = () => {
  const [defaults, setDefaults] = useState<DefaultsType>();

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection(firestoreCollection.projectDefaults)
      .onSnapshot(
        (snapshot) => {
          const first = snapshot.docs[0];
          if (first) setDefaults(first.data() as DefaultsType);
        },
        (error) => console.warn('Project field labels unavailable:', error.message),
      );
    return () => unsubscribe();
  }, []);
  return { defaults };
};

export default useDefaultFieldsListener;
